module.exports = __webpack_public_path__ + "img/app.bf0c7979.png";